export const GRAPHQL_ENDPOINT_URL = `${import.meta.env.VITE_SERVER_URL}/graphql`;
